import React, { ReactElement } from 'react';

export type DotState = 'default' | 'error' | 'correct' | 'critical';
export type DotSize = 'mini' | 'normal' | 'large';

const ERROR_RED = '#e80f56';
const CRITICAL_RED = '#e93418';
const GATING_COLOR = '#CC8500';
const CORRECT_GREEN = '#3B9C7C';
// const DEFAULT_GRADIENT = 'url(#linear-gradient)';

function DotIcon({
    label,
    state,
    gated,
}: {
    label?: string;
    state: DotState;
    gated: boolean;
}): ReactElement {
    let viewbox = '0 0 32 32';
    let width = '32';
    let height = '32';
    let content = (
        <>
            <circle
                cx="16"
                cy="16"
                r="16"
                transform="translate(0 32) rotate(-90)"
                fill="url(#linear-gradient)"
            />
            {label ? (
                // see https://stackoverflow.com/questions/5546346/how-to-place-and-center-text-in-an-svg-rectangle
                <text
                    fontSize="20px"
                    fill="white"
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontFamily="Raleway"
                >
                    {label}
                </text>
            ) : (
                <>
                    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Subtraction_31)">
                        <path
                            id="Subtraction_31-2"
                            data-name="Subtraction 31"
                            d="M2608.554-14847.37a.97.97,0,0,0,.766.341.97.97,0,0,0,.766-.341l12.555-12.513a1.035,1.035,0,0,0,.3-.766,1.035,1.035,0,0,0-.3-.766l-1.575-1.532a.948.948,0,0,0-.745-.341,1.079,1.079,0,0,0-.787.341l-10.214,10.214-4.767-4.767a1.083,1.083,0,0,0-.787-.341.951.951,0,0,0-.745.341l-1.575,1.532a1.037,1.037,0,0,0-.3.766,1.039,1.039,0,0,0,.3.767Z"
                            transform="translate(-2595.78 14871.66)"
                            fill="#fff"
                        />
                    </g>
                </>
            )}
        </>
    );
    let gradient = (
        <>
            <stop offset="0" stopColor="#69b49b" />
            <stop offset="0.46" stopColor="#409f80" />
            <stop offset="1" stopColor={CORRECT_GREEN} />
        </>
    );
    if (state === 'error') {
        gradient = (
            <>
                <stop offset="0" stopColor="#eb3c76" />
                <stop offset="0.508" stopColor="#e92264" />
                <stop offset="1" stopColor={ERROR_RED} />
            </>
        );
        if (gated) {
            viewbox = '0 0 36.875 37.875';
            width = '36.875';
            height = '37.875';
            gradient = (
                <>
                    <stop offset="0" stopColor="#f8aa4c" />
                    <stop offset="0.527" stopColor={GATING_COLOR} />
                    <stop offset="1" stopColor="#d28a0a" />
                </>
            );
            content = (
                <>
                    <g transform="translate(0 3.998)">
                        <g transform="translate(-272.002 -118.998)">
                            <path
                                d="M2612-17964a15.9,15.9,0,0,1-11.313-4.687A15.889,15.889,0,0,1,2596-17980a15.906,15.906,0,0,1,4.685-11.316A15.9,15.9,0,0,1,2612-17996a16.1,16.1,0,0,1,4.118.535A9.054,9.054,0,0,0,2616-17994a9.01,9.01,0,0,0,9,9,9.192,9.192,0,0,0,2.118-.25A15.97,15.97,0,0,1,2628-17980a15.889,15.889,0,0,1-4.685,11.311A15.9,15.9,0,0,1,2612-17964Z"
                                transform="translate(-2324 18115)"
                                fill="url(#linear-gradient)"
                            />
                        </g>
                    </g>
                    <g transform="translate(-802.002 -132)">
                        <circle
                            cx="6.5"
                            cy="6.5"
                            r="6.5"
                            transform="translate(824 132)"
                            fill="#e2bf42"
                        />
                        <path
                            d="M-.347-6.293a.455.455,0,0,1,.262-.24.51.51,0,0,1,.344,0,.455.455,0,0,1,.262.24l.973,1.976L3.68-4a.454.454,0,0,1,.307.18.5.5,0,0,1,.1.329.46.46,0,0,1-.142.314L2.363-1.636,2.737.55A.473.473,0,0,1,2.67.887a.44.44,0,0,1-.277.2.462.462,0,0,1-.344-.045L.087.026-1.875,1.044a.462.462,0,0,1-.344.045A.44.44,0,0,1-2.5.887.473.473,0,0,1-2.563.55l.374-2.186L-3.776-3.179a.46.46,0,0,1-.142-.314.5.5,0,0,1,.1-.329A.454.454,0,0,1-3.507-4l2.186-.314Z"
                            transform="translate(830.413 141.053)"
                            fill="#fff"
                        />
                    </g>
                    <text
                        fontSize="17px"
                        fill="white"
                        x="44%"
                        y="53%"
                        textAnchor="middle"
                        dominantBaseline="middle"
                        fontFamily="Raleway"
                    >
                        {label}
                    </text>
                </>
            );
        }
    }
    if (state === 'critical') {
        gradient = (
            <>
                <stop offset="0" stopColor="#e93f25" />
                <stop offset="0.508" stopColor={CRITICAL_RED} />
                <stop offset="1" stopColor={CRITICAL_RED} />
            </>
        );
        content = (
            <>
                <circle
                    cx="16"
                    cy="16"
                    r="16"
                    transform="translate(0 32) rotate(-90)"
                    fill="url(#linear-gradient)"
                />
                <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_4313)">
                    <path
                        id="Path_4313-2"
                        data-name="Path 4313"
                        d="M16.01,8.619,7.254-6.557a1.636,1.636,0,0,0-.93-.784,1.856,1.856,0,0,0-1.2,0,1.636,1.636,0,0,0-.93.784L-4.566,8.619A1.851,1.851,0,0,0-4.748,9.8a1.75,1.75,0,0,0,.584,1.021,1.65,1.65,0,0,0,1.131.42H14.477a1.65,1.65,0,0,0,1.131-.42A1.75,1.75,0,0,0,16.192,9.8,1.851,1.851,0,0,0,16.01,8.619ZM5.722,5.482A1.682,1.682,0,0,1,7.4,7.16,1.682,1.682,0,0,1,5.722,8.838,1.682,1.682,0,0,1,4.044,7.16,1.682,1.682,0,0,1,5.722,5.482ZM4.117-.538a.468.468,0,0,1,.128-.347.422.422,0,0,1,.31-.128H6.889a.422.422,0,0,1,.31.128.468.468,0,0,1,.128.347L7.035,4.424a.383.383,0,0,1-.128.274.422.422,0,0,1-.31.128H4.846a.422.422,0,0,1-.31-.128.383.383,0,0,1-.128-.274Z"
                        transform="translate(10.28 12.81)"
                        fill="#fff"
                    />
                </g>
            </>
        );
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={width}
            height={height}
            viewBox={viewbox}
        >
            <defs>
                <linearGradient
                    id="linear-gradient"
                    x1="0.843"
                    y1="0.157"
                    x2="0.124"
                    y2="0.838"
                    gradientUnits="objectBoundingBox"
                >
                    {gradient}
                </linearGradient>
                <filter
                    id="Subtraction_31"
                    x="0.872"
                    y="3.871"
                    width="30.791"
                    height="25.258"
                    filterUnits="userSpaceOnUse"
                >
                    <feGaussianBlur stdDeviation="1.5" result="blur" />
                    <feFlood floodOpacity="0.161" />
                    <feComposite operator="in" in2="blur" />
                    <feComposite in="SourceGraphic" />
                </filter>
                <filter
                    id="Path_4313"
                    x="1"
                    y="0.873"
                    width="30"
                    height="27.688"
                    filterUnits="userSpaceOnUse"
                >
                    <feGaussianBlur stdDeviation="1.5" result="blur" />
                    <feFlood floodOpacity="0.161" />
                    <feComposite operator="in" in2="blur" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            {content}
        </svg>
    );
}

export default DotIcon;
